<div class="modal-wrapper">
  <common-icon-button
    class="modal-close-button"
    variant="plain"
    icon="close"
    ariaLabel="Close"
    color="weak"
    type="filled"
    size="small"
    [stopClickPropagation]="true"
    (output)="onClose()"
  ></common-icon-button>
  <div class="modal-header">
    <div class="modal-header__left">
      <h2 class="h6_500 modal-title" mat-dialog-title>
        {{ data.titleKey | translate }}
      </h2>
      <p *ngIf="data.subtitleKey" class="modal-subtitle">
        {{ data.subtitleKey | translate }}
      </p>
    </div>

    <div class="modal-header__right">
      <app-filter-text-field
        [control]="filterControl"
        size="large"
        widthLayout="ds"
        [placeholder]="'areasV2.newArea.iconPicker.filterPlaceholder' | translate"
        iconTrailing="search"
      ></app-filter-text-field>
    </div>
  </div>

  <mat-dialog-content class="modal-content">
    <div class="area-icon-picker__grid" role="list">
      <common-icon-area-card
        *ngFor="let img of filteredImages; trackBy: trackByImageId"
        role="listitem"
        [title]="getImageTitle(img)"
        [status]="isSelected(img) ? 'selected' : 'default'"
        [imageUrl]="img.urlv3 || img.url"
        [disabled]="img.status !== 'active'"
        (select)="onSelect(img)"
      ></common-icon-area-card>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="modal-actions">
    <common-buttons-outlined
      [label]="data.cancelLabelKey | translate"
      [iconPosition]="false"
      (output)="onCancel()"
    ></common-buttons-outlined>

    <common-buttons-filled
      [label]="data.saveLabelKey | translate"
      [disabled]="!selectedId"
      [iconPosition]="false"
      (output)="onSave()"
    ></common-buttons-filled>
  </mat-dialog-actions>
</div>

